import { render, staticRenderFns } from "./p2p-form.vue?vue&type=template&id=13977a74&"
import script from "./p2p-form.vue?vue&type=script&lang=js&"
export * from "./p2p-form.vue?vue&type=script&lang=js&"
import style0 from "./p2p-form.vue?vue&type=style&index=0&id=13977a74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports